import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { tableTheme } from '../../helpers/tableTheme';
import { Modal } from '@themesberg/react-bootstrap';
import { Card, Col, Button, Row, Spinner } from '@themesberg/react-bootstrap';
import {
  clearBatchByDate,
  clearTransactionsByBatch,
  getBatchByDate,
  getTransactionsByBatchId,
  verifyBatch,
} from '../../redux/actions/batch';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import CustomErrorView from '../../components/CustomErrorView';
import LabelValue from '../../components/LabelValue';
import ColorComponent from '../../components/ColorComponent';
import Labels from '../../components/Labels';

const columns = [
  {
    name: 'Transaction Id',
    label: 'Transaction Id',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'CustomerId',
    label: 'CustomerId',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'Customer Name',
    label: 'Customer Name',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'Customer Contact Number',
    label: 'Customer Contact Number',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'Amount',
    label: 'Amount',
    options: {
      filter: false,
      sort: true,
    },
  },

  {
    name: 'Transaction Type',
    options: {
      customBodyRender: (value) => {
        return <ColorComponent value={value} />;
      },
    },
  },
];

function ViewTransactionsByBatchId({ history, match }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showErrPage, setShowErrPage] = useState(false);
  const [ID, setID] = useState('');

  const transactionsData = useSelector(
    (state) => state.batch.individualBatchTransactions
  );
  const batchInfo = useSelector((state) => state.batch.individualBatchInfo);

  const [isLoading, setIsLoading] = useState(false);

  const handleSuccess = () => {
    handleClose();
    setIsLoading(true);
    dispatch(getTransactionsByBatchId(ID)).then(() => setIsLoading(false));
  };
  const handleFailure = () => {
    setIsSubmitting(false);
  };

  const verifyHandler = () => {
    setIsSubmitting(true);
    dispatch(verifyBatch(ID, handleSuccess, handleFailure));
  };

  useEffect(() => {
    const someId = match.params?.id;
    if (!someId) {
      setShowErrPage(true);
    } else {
      setIsLoading(true);
      setID(someId);
      dispatch(getTransactionsByBatchId(someId)).then(() =>
        setIsLoading(false)
      );
    }
    return () => {
      dispatch(clearTransactionsByBatch());
    };
  }, []);

  const onRowsSelect = (rowData, rowMeta) => {
    history.push(`/customers/profile/transactions/${rowData[1]}`);
  };
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    onRowClick: onRowsSelect,
    responsive: 'standard',
    print: false,
    download: false,
    elevation: 0,
  };

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <>
        {isLoading ? (
          <div
            className='d-flex justify-content-center align-items-center'
            style={{
              height: '50vh',
            }}
          >
            <Spinner animation='border' />
          </div>
        ) : (
          <>
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Verify Batch</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Do you want to verify the payments of this batch?
              </Modal.Body>
              <Modal.Footer>
                <Button variant='secondary' onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  variant='primary'
                  onClick={verifyHandler}
                  disabled={isSubmitting}
                >
                  {isSubmitting === true ? (
                    <Spinner animation='border' />
                  ) : (
                    'Verify this batch Payments'
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
            <Col md={12} className={'mt-3'}>
              <Card border='light' className='bg-white shadow-sm mb-4 p-0'>
                <Card.Body>
                  <Row className='d-flex align-items-center'>
                    <Col md={12} lg={6}>
                      <h5>Transactions of Batch No. {batchInfo.batch_id}</h5>
                    </Col>

                    <Col
                      md={12}
                      lg={6}
                      className='d-flex'
                      style={{ justifyContent: 'flex-end' }}
                    >
                      <Button
                        variant={`primary ${
                          batchInfo.status === 'VERIFIED' &&
                          'background-light-green'
                        }`}
                        onClick={handleShow}
                        disabled={batchInfo.status !== 'PENDING'}
                      >
                        {batchInfo.status === 'VERIFIED'
                          ? 'VERIFIED'
                          : 'Verify Batch Payments'}
                      </Button>
                    </Col>

                    {/* {batchInfo.status === "PENDING" && (
                      <Col
                        md={12}
                        lg={6}
                        className="d-flex"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Button variant="primary" onClick={handleShow}>
                          Verify Batch Payments
                        </Button>
                      </Col>
                    )} */}
                  </Row>
                  <Row>
                    {/* {Labels('Customer Id', individualCustomer?.customerId)} */}
                    <Labels keyName={'Date'} value={batchInfo.date} />
                    <Labels
                      keyName={'Collector Name'}
                      value={batchInfo?.collector?.name}
                      link={() =>
                        history.push(
                          `/collectors/profile/${batchInfo?.collector?.id}`
                        )
                      }
                    />
                    <Labels
                      keyName={'Collector Username'}
                      value={batchInfo?.collector?.username}
                    />
                    <Labels
                      keyName={'Collector Contact'}
                      value={batchInfo?.collector?.mobileNumber}
                    />
                    <Labels
                      keyName={'Status'}
                      value={batchInfo.status}
                      colored
                    />
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <div>
              <MuiThemeProvider theme={tableTheme}>
                <MUIDataTable
                  title={'All Transactions'}
                  data={transactionsData}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            </div>
          </>
        )}
      </>
    );
  }
}

export default ViewTransactionsByBatchId;
